/**
 * Route for `affiliate-referral-program`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { AffiliateReferralProgramPage } from "../features/affiliate-referral-program/AffiliateReferralProgramPage";

export const affiliateReferralProgramRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/affiliate-referral-program",
	component: AffiliateReferralProgramPage,
});

export default affiliateReferralProgramRoute;
